import { set } from "@/utils/vuex";

export default {
  setDrawer: set("drawer"),
  setUserLoggedIn: set("userLoggedIn"),
  setUserInfo: set("userInfo"),
  setShowTransactionFilters: set("showTransactionFilters"),
  resetAppState(state) {
    state.drawer = null;
    state.showTransactionFilters = false;
    state.userLoggedIn = false;
    state.userInfo = {};
  },
};
